// get number of decimals in a float
function get_number_of_decimal_places(value) {
	if (Math.floor(value) === value) {
		return 0;
	}
	return value.toString().split('.')[1].length || 0;
}

$(document).ready(function() {
	
	// newsletter form submission
	var newsletter_form = $('#pw3-newsletter-form').validate({
		// debug: true,
		errorElement: 'span',
		errorClass: 'form-field-error',
		validClass: 'form-field-valid',
		errorPlacement: function (error, element) {
			error.appendTo(element.parents('.form-field'));
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
		},
		rules: {
			'pw3-newsletter-form-email-address': {
				required: true,
				email: true
			}
		},
		messages: {
			'pw3-newsletter-form-email-address': {
				required: 'Please enter your email address.',
				email: 'Please enter a valid email address.'
			}
		},
		submitHandler: function (form) {
			alert('We need to hook this up to an email newsletter service?');
		}
	});
	
	var stuff = $('.pw3-page-header-slides-group');
	if (stuff) {
		$(stuff).each(function(index, group) {
			var slider = $(group).flickity({
				cellAlign: 'center',
				pageDots: false,
				prevNextButtons: false,
				wrapAround: true
			});
		});
	}
	
	// block :: application process slider
	var application_process_sliders = $('.pw3-block-application-process-slider');
	if (application_process_sliders) {
		$(application_process_sliders).each(function(index, group) {
			var application_process_slider = $('.pw3-application-process-slides-group', group).flickity({
				adaptiveHeight: true,
				cellAlign: 'left',
				contain: false,
				pageDots: false,
				percentPosition: true,
				prevNextButtons: false,
				setGallerySize: true,
				wrapAround: false
			});
			application_process_slider.on('change.flickity', function(event, index) {
				$('.pw3-application-process-slider-tab', group).removeClass('pw3-application-process-slider-tab-active');
				$('.pw3-application-process-slider-tab[data-slide="' + index + '"]', group).addClass('pw3-application-process-slider-tab-active');
			});
			$('.pw3-application-process-slider-tab', group).on('click', function() {
				if (!$(this).hasClass('pw3-application-process-slider-tab-active')) {
					var index = $(this).attr('data-slide');
					$('.pw3-application-process-slider-tab', group).removeClass('pw3-application-process-slider-tab-active');
					$(this).addClass('pw3-application-process-slider-tab-active');
					application_process_slider.flickity('select', index, false, false);
				}
			});
		});
	}
	
	// block :: blog posts slider functionality 
	var blog_posts_sliders = $('.pw3-blog-posts-slider');
	if (blog_posts_sliders) {
		$(blog_posts_sliders).each(function(index, slider) {
			var blog_posts_slider = $('.pw3-blog-posts-slides-group', slider).flickity({
				adaptiveHeight: false,
				cellAlign: 'left',
				contain: false,
				pageDots: false,
				percentPosition: true,
				prevNextButtons: false,
				setGallerySize: true,
				wrapAround: false
			});
			$('.pw3-slider-button-previous', slider).on('click', function() {
				blog_posts_slider.flickity('previous');
			});
			$('.pw3-slider-button-next', slider).on('click', function() {
				blog_posts_slider.flickity('next');
			});
		});
	}
	
	// block :: culture accordion functionality
	var culture_accordions = $('.pw3-culture-accordion');
	if (culture_accordions) {
		$(culture_accordions).each(function(index, accordion) {
			var culture_accordion = $('.pw3-culture-accordion-images-group', accordion).flickity({
				adaptiveHeight: false,
				cellAlign: 'left',
				contain: false,
				draggable: false,
				fade: true,
				pageDots: false,
				percentPosition: true,
				prevNextButtons: false,
				setGallerySize: true,
				wrapAround: true
			});
			$('.pw3-culture-accordion-item-title', accordion).on('click', function() {
				var parent = $(this).parent();
				var index = $(parent).attr('data-slide');
				if (!$(parent).hasClass('pw3-culture-accordion-item-active')) {
					$('.pw3-culture-accordion-item', accordion).removeClass('pw3-culture-accordion-item-active');
					$(this).parent().addClass('pw3-culture-accordion-item-active');	
					culture_accordion.flickity('select', index);
				}
			});
		});
	}
	
	// block :: photo gallery functionality
	var photo_galleries = $('.pw3-photo-gallery-items-group');
	if (photo_galleries) {
		$(photo_galleries).each(function(index, gallery) {
			var photo_gallery = $(gallery).flickity({
				adaptiveHeight: true,
				cellAlign: 'center',
				contain: true,
				pageDots: true,
				percentPosition: true,
				prevNextButtons: false,
				setGallerySize: true,
				wrapAround: true
			});
		});
	}
	
	// block :: solutions accordion (individual)
	var groups = $('.pw3-solution-box-accordion-items-group');
	if (groups) {
		$(groups).each(function(index, group) {
			$('.pw3-solution-box-accordion-item-title', group).on('click', function() {
				var parent = $(this).parent();
				if (!$(parent).hasClass('pw3-solution-box-accordion-item-active')) {
					$('.pw3-solution-box-accordion-item', group).removeClass('pw3-solution-box-accordion-item-active');
					$(parent).addClass('pw3-solution-box-accordion-item-active');	
				}
			});
		});
	}
	
	// block :: solutions accordion (all) functionality
	var solutions_accordions_all = $('.pw3-solutions-accordion-all');
	if (solutions_accordions_all) {
		$(solutions_accordions_all).each(function(index, accordion) {
			var solutions_accordion_all = $('.pw3-solutions-accordion-all-media-group', accordion).flickity({
				adaptiveHeight: false,
				cellAlign: 'center',
				contain: true,
				fade: true,
				pageDots: false,
				percentPosition: true,
				prevNextButtons: false,
				setGallerySize: true,
				wrapAround: true
			});
			solutions_accordion_all.on('change.flickity', function(event, index) {
				$('.pw3-solutions-accordion-all-item', accordion).removeClass('pw3-solutions-accordion-all-item-active');
				$('.pw3-solutions-accordion-all-item[data-slide="' + index + '"]', accordion).addClass('pw3-solutions-accordion-all-item-active');
			});
			
			
			// solutions_accordion_all.on('change.flickity', function(event, index) {
			// 	$('.pw3-solutions-accordion-all-item', accordion).removeClass('pw3-solutions-accordion-all-item-active');
			// 	$('.pw3-solutions-accordion-all-item[data-slide="' + index + '"]', group).addClass('pw3-solutions-accordion-all-item-active');
			// });
			$('.pw3-solutions-accordion-all-item-title', accordion).on('click', function() {
				var parent = $(this).parent();
				var index = $(parent).attr('data-slide');
				if (!$(parent).hasClass('pw3-solutions-accordion-all-item-active')) {
					$('.pw3-solutions-accordion-all-item', accordion).removeClass('pw3-solutions-accordion-all-item-active');
					$(parent).addClass('pw3-solutions-accordion-all-item-active');
					solutions_accordion_all.flickity('select', index, false, false);
				}
			});
		});
	}
	
	// block :: statistics grid functionality
	
	// count up statistics from zero
	$('.pw3-statistic-cards-group, .pw3-statistic-cards-grid').each(function(index, group) {
		var statistics = $('.pw3-statistic-card', group);
		$(statistics).each(function(index, statistic) {
			var target = $('.pw3-statistic-card-number', statistic)[0];
			var end_number = $(target).attr('data-number') * 1;
			var prefix = $(target).attr('data-prefix');
			var suffix = $(target).attr('data-suffix');
			var decimal_places = get_number_of_decimal_places(end_number);
			var options = {
				startVal: 0,
				decimalPlaces: decimal_places,
				duration: 3,
				useGrouping: true,
				useEasing: true,
				prefix: prefix,
				suffix: suffix,
				enableScrollSpy: true,
				scrollSpyOnce: true
			};
			var counter = new CountUp(target, end_number, options);
		});
	});
	
	// block :: testimonials slider functionality
	var testimonials_sliders = $('.pw3-testimonial-slider');
	if (testimonials_sliders) {
		$(testimonials_sliders).each(function(index, slider) {
			var testimonials_slider = $('.pw3-testimonial-slides-group', slider).flickity({
				adaptiveHeight: true,
				cellAlign: 'center',
				contain: true,
				pageDots: false,
				percentPosition: true,
				prevNextButtons: false,
				setGallerySize: true,
				wrapAround: true
			});
			$('.pw3-slider-button-previous', slider).on('click', function() {
				testimonials_slider.flickity('previous');
			});
			$('.pw3-slider-button-next', slider).on('click', function() {
				testimonials_slider.flickity('next');
			});
		});
	}
	
	// block :: values accordion functionality
	var values_accordions = $('.pw3-values-accordion');
	if (values_accordions) {
		$(values_accordions).each(function(index, accordion) {
			$('.pw3-values-accordion-item-summary', accordion).on('click', function() {
				var parent = $(this).parent();
				if (!$(parent).hasClass('pw3-values-accordion-item-active')) {
					$('.pw3-values-accordion-item', accordion).removeClass('pw3-values-accordion-item-active');
					$(parent).addClass('pw3-values-accordion-item-active');
				}
			});
		});
	}
	
});